export const intercomServiceConfig = {
  region: process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION,
};
